import { useCallback, useContext, useEffect, useState } from "react";
import { Flex } from "uikit-react";
import { useCookies } from "react-cookie";
import moment from "moment";

import Pagination from "../../common/Pagination";
import RecordsPerPage from "../../common/RecordsPerPage";
import { AppContexts } from "../../../providers";

import FilterPanel from "../Common/FilterPanel";
import usePath from "../Common/History";

const SmartLockLogs = () => {
  const [filter, setFilter] = useState("");
  const [page, setPage] = useState(0);
  const [cookies] = useCookies(["records-per-page"]);
  const { "records-per-page": recordsPerPage = 20 } = cookies;

  const { active, smartLockLogs, startDate, endDate, getSmartLockLogs } =
    useContext(AppContexts.ReportsContext);

  const path = usePath();
  const { total, paginated } = smartLockLogs;

  useEffect(() => {
    if (path !== active) {
      setPage(0);
      setFilter("");
    }
  }, [path]);

  useEffect(() => {
    if (active === "smart-lock-logs") getFn(startDate, endDate);
  }, [page, filter, recordsPerPage]);

  const getFn = useCallback(
    (start, end) => {
      if (!start || !end) {
        return;
      } else {
        getSmartLockLogs(
          start,
          end,
          page,
          recordsPerPage,
          filter ? filter.trim() : filter
        );
      }
    },
    [page, filter, recordsPerPage]
  );

  const handlePageChange = useCallback((page) => setPage(page), []);
  const handleFilterChange = useCallback((filter) => setFilter(filter), []);

  return (
    <li className="reports-tab-content">
      <h2>Smart Lock Logs</h2>
      <div className="uk-card hms-left-tabs-content-card uk-padding-remove">
        <FilterPanel
          searchTermPlaceholder="Guest Name or PMS ID"
          onFilterChange={handleFilterChange}
          onSubmit={getFn}
        />
        <table className="uk-table uk-table-hover uk-table-divider hms-table uk-margin-small-top">
          <thead>
            <tr>
              <th>ACTIVITY DATE</th>
              <th>STATUS</th>
              <th>RESERVATION ID</th>
              <th>GUEST NAME</th>
              <th>CHECK-IN</th>
              <th>CHECK-OUT</th>
              <th>PMS ID</th>
              <th>DOOR CODE</th>
            </tr>
          </thead>
          <tbody>
            {paginated?.length ? (
              paginated?.map((item, idx) => (
                <tr key={idx}>
                  <td>
                    {moment
                      .utc(item.created_at)
                      .local()
                      .format("MM/DD/YYYY hh:mm A")}
                  </td>
                  <td>{item.status}</td>
                  <td>{item.reservation_id}</td>
                  <td>
                    {item.first_name} {item.last_name}
                  </td>
                  <td>
                    {item.check_in
                      ? moment.utc(item.check_in).format("MM/DD/YYYY")
                      : ""}
                  </td>
                  <td>
                    {item.check_out
                      ? moment.utc(item.check_out).format("MM/DD/YYYY")
                      : ""}
                  </td>
                  <td>{item.pms_id}</td>
                  <td>{item.door_code}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8} className="no-results">
                  No results for this date range
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Flex alignment="between top" className="guest-form-top-filters">
        <Pagination
          count={total}
          index={page}
          onIndexChanged={handlePageChange}
        />
        {total > 0 && <RecordsPerPage />}
      </Flex>
    </li>
  );
};

export default SmartLockLogs;
